// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader-module__header__3iPlq"};